import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2639db12"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "wx-open-arrow",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 120 80",
    width: "88",
    height: "60"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20 60 C40 20, 70 10, 100 18",
      fill: "none",
      stroke: "#fff",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M88 8 L108 18 L90 30",
      fill: "none",
      stroke: "#fff",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_2 = { class: "wx-open-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wx-open-title" }, "请在浏览器中打开", -1))
const _hoisted_4 = { class: "wx-open-steps" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("1. 点击右上角 "),
  /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "···")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wx-open-hint" }, "微信内无法完整展示，请用系统浏览器访问", -1))
const _hoisted_7 = ["onClick"]

import { computed, ref } from "vue";
import { isIOS, isWechatBrowser } from "@/utils/ua";


export default /*#__PURE__*/_defineComponent({
  __name: 'WechatOpenBrowserMask',
  setup(__props) {

const visible = computed(() => isWechatBrowser());
const browserName = computed(() => (isIOS() ? "Safari" : "浏览器"));
const copied = ref(false);

async function copyLink() {
	const url = window.location.href;
	try {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			await navigator.clipboard.writeText(url);
		} else {
			const input = document.createElement("input");
			input.value = url;
			input.setAttribute("readonly", "readonly");
			input.style.position = "fixed";
			input.style.left = "-9999px";
			document.body.appendChild(input);
			input.select();
			document.execCommand("copy");
			document.body.removeChild(input);
		}
		copied.value = true;
		setTimeout(() => {
			copied.value = false;
		}, 2000);
	} catch (e) {
		console.error(e);
		window.prompt("请复制以下链接到浏览器打开", url);
	}
}

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "wx-open-mask",
        onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", null, "2. 选择「在" + _toDisplayString(_unref(browserName)) + "中打开」", 1)
          ]),
          _hoisted_6,
          _createElementVNode("button", {
            class: "wx-open-copy",
            type: "button",
            onClick: _withModifiers(copyLink, ["stop"])
          }, _toDisplayString(copied.value ? "链接已复制" : "复制链接去浏览器打开"), 9, _hoisted_7)
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})